import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    total: 0,
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload);
      state.total += action.payload.price;
    },
    removeItem: (state, action) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.total -= state.items[index].price;
        state.items.splice(index, 1);
      }
    },
    setCart: (state, action) => {
      state.items = action.payload.items;
      state.total = action.payload.totalPrice;
    },
  },
});

export const { addItem, removeItem, setCart } = cartSlice.actions;
export default cartSlice.reducer;